module.exports = __webpack_public_path__ + "static/media/background.6ba2372c.png";